import { Box, Stack, Typography } from '@mui/material'
import { useContext } from 'react'
import { TSubscriptionDetails } from '../../../../../../core/types/CheckoutOrder'
import { AuthContext } from '../../../../../../core/context/AuthContext'
import { TProductVoucherValue } from '../../../../../../core/types/Voucher'
import ListItemDefault from '../../../../../../components/ListItem/ListItemDefault'
import NumberFunctions from '../../../../../../core/functions/NumberFunctions'
import ListItemDetail from '../../../../../../components/ListItem/ListItemDetail'

export interface IOrderDetailValuesProp {
  subscription?: TSubscriptionDetails
}

const SubscriptionOrderDetailValues = ({
  subscription,
}: IOrderDetailValuesProp) => {
  const { isUserSysAdmin, getTenantId } = useContext(AuthContext)

  const basePrice = subscription?.orderDetails?.basePrice ?? 0
  const voucherValue = subscription?.orderDetails?.voucherValue ?? 0

  const isVoucher =
    subscription?.orderDetails?.voucherIdentifier !== undefined &&
    subscription?.orderDetails?.voucherIdentifier !== null &&
    subscription?.orderDetails?.voucherIdentifier !== ''

  const isVoucherValue =
    isVoucher &&
    subscription?.orderDetails?.voucherType === TProductVoucherValue.value

  const isVoucherPercentage =
    isVoucher &&
    subscription?.orderDetails?.voucherType === TProductVoucherValue.percentage

  const discount = (basePrice * voucherValue) / 100

  return (
    <Box>
      <ListItemDefault
        title="Preço base do produto"
        value={NumberFunctions.formatMoneyDefault(
          basePrice,
          subscription?.currency === 'usd' ? 'usd' : 'brl'
        )}
      />
      {isVoucherValue && (
        <ListItemDefault
          title="Desconto"
          value={NumberFunctions.formatMoneyDefault(
            voucherValue,
            subscription?.currency === 'usd' ? 'usd' : 'brl'
          )}
        />
      )}
      {isVoucherPercentage && (
        <ListItemDefault
          title="Desconto"
          value={NumberFunctions.formatMoneyDefault(
            discount,
            subscription?.currency === 'usd' ? 'usd' : 'brl'
          )}
        />
      )}
      <ListItemDefault
        title="Taxas"
        value={NumberFunctions.formatMoneyDefault(
          subscription?.orderDetails?.rates,
          subscription?.currency === 'usd' ? 'usd' : 'brl'
        )}
      />
      {(isUserSysAdmin() ||
        getTenantId() === subscription?.orderDetails?.tenantId) && (
        <ListItemDefault title="" px={0} py={0}>
          <Box width="100%">
            <ListItemDetail
              title="Divisão dos valores"
              value={
                <Stack direction="column" spacing={1}>
                  {subscription?.orderDetails?.recipients?.map((recipient) => (
                    <Box>
                      <Stack
                        display="inline"
                        direction="row"
                        spacing={1}
                        alignContent="center"
                        alignItems="center"
                      >
                        <Typography display="inline" variant="subtitle2">
                          {recipient.name}:
                        </Typography>
                        <Typography display="inline" variant="body2">
                          {NumberFunctions.formatMoneyDefault(
                            recipient.value,
                            subscription?.currency === 'usd' ? 'usd' : 'brl'
                          )}
                        </Typography>
                      </Stack>
                    </Box>
                  ))}
                </Stack>
              }
              viewDivider={false}
            />
          </Box>
        </ListItemDefault>
      )}
      <Typography variant="subtitle2" sx={{ px: 2, py: 1 }}>
        Seu recebimento
      </Typography>
      <ListItemDefault
        title="Valor"
        value={NumberFunctions.formatMoneyDefault(
          subscription?.orderDetails?.value,
          subscription?.currency === 'usd' ? 'usd' : 'brl'
        )}
      />
    </Box>
  )
}

export default SubscriptionOrderDetailValues
